import type { Followup } from './types'

/** Map profession to i18n key for the group label */
export function getGroupLabelKey(profession: string | null): string {
  switch (profession?.toLowerCase()) {
    case 'sales':
      return 'groupLabel.deals'
    case 'consulting':
      return 'groupLabel.clients'
    case 'real_estate':
      return 'groupLabel.listings'
    case 'trades':
      return 'groupLabel.jobs'
    case 'freelancer':
      return 'groupLabel.projects'
    default:
      return 'groupLabel.groups'
  }
}

export interface FollowupGroup {
  name: string | null
  items: Followup[]
}

/** Group follow-ups by groupName. Named groups sorted alphabetically, ungrouped last. */
export function groupFollowups(items: Followup[]): FollowupGroup[] {
  const grouped = new Map<string | null, Followup[]>()

  for (const item of items) {
    const key = item.groupName ?? null
    const list = grouped.get(key) ?? []
    list.push(item)
    grouped.set(key, list)
  }

  const result: FollowupGroup[] = []
  const ungrouped = grouped.get(null)

  // Named groups sorted alphabetically
  const namedKeys = [...grouped.keys()]
    .filter((k): k is string => k !== null)
    .sort((a, b) => a.localeCompare(b))

  for (const name of namedKeys) {
    result.push({ name, items: grouped.get(name)! })
  }

  // Ungrouped last
  if (ungrouped) {
    result.push({ name: null, items: ungrouped })
  }

  return result
}
